import React, { useState } from "react";
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import "../style/NavMenu.css";
import { connect } from "react-redux";
import { userActions } from "../_actions/user.actions";
import ListGroup from "react-bootstrap/ListGroup";
import navBarLogo from "../Content/images/cw_navbar_logo_new.png";
import { logout } from "../Services/ReportingService";

const NavMenu = (props) => {
  const [collapsed, setCollapsed] = useState(true);

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  const changeDisplayPage = (pageName) => {
    props.changePage(pageName);
  };

  const loggedIn = sessionStorage.getItem("crmUser") !== null;

  return (
    <header>
      <Navbar
        className="navbar-fixed-top navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 p-0 row"
        light
      >
        <Container>
          <div className="row">
            <div className="d-sm-inline-flex">
              <NavbarBrand tag={Link} to="/">
                <img alt="logo" height="50" width="100" className={`navbar-brand`} id="navBarLogo" src={navBarLogo} />
                CWFS Core{" "}
                {process.env.REACT_APP_ENVIRONMENT && process.env.REACT_APP_ENVIRONMENT !== "prod"
                  ? process.env.REACT_APP_ENVIRONMENT.toUpperCase()
                  : ""}
              </NavbarBrand>
              <NavbarToggler onClick={toggleNavbar} className="mr-2" />
              <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                <ListGroup className="navbar-nav align-items-end" variant="flush">
                  {loggedIn && (
                    <ListGroup.Item
                      className="nav-button text-dark"
                      id="BundlesButton"
                      action
                      onClick={() => {
                        changeDisplayPage("Bundles");
                        props.history.push("/bundles");
                      }}
                    >
                      Bundles
                    </ListGroup.Item>
                  )}
                  {loggedIn && (
                    <ListGroup.Item
                      className="nav-button text-dark"
                      id="UserSummaryButton"
                      action
                      onClick={() => {
                        changeDisplayPage("UserSummary");
                        props.history.push("/user-summary");
                      }}
                    >
                      Users
                    </ListGroup.Item>
                  )}
                  {/* {props.adminAccess && props.crmUser && (
                    <ListGroup.Item
                      className="nav-button text-dark"
                      id="RequestStatusButton"
                      action
                      onClick={() => {
                        changeDisplayPage("AdminUserActions");
                        props.history.push("/user-actions-summary");
                      }}
                    >
                      Request Status
                    </ListGroup.Item>
                  )} */}
                  <ListGroup.Item
                    className="nav-button text-dark"
                    id="LoginButton"
                    action
                    onClick={() => {
                      logout();
                    }}
                  >
                    {loggedIn ? "Logout" : "Login"}
                  </ListGroup.Item>
                  <ListGroup.Item disabled={true}></ListGroup.Item>
                </ListGroup>
              </Collapse>
            </div>
          </div>
        </Container>
      </Navbar>
    </header>
  );
};

const mapStateToProps = (state) => {
  const { authentication } = state;
  const { crmUser } = authentication;
  const { adminAccess } = authentication;
  return { crmUser, adminAccess };
};

const actionCreators = {
  logout: userActions.logout,
  changePage: userActions.changePage,
};

const connectedNavBar = connect(mapStateToProps, actionCreators)(withRouter(NavMenu));
export { connectedNavBar as NavMenu };
